var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TagSelector',{attrs:{"items":_vm.greenhouse_job_posts,"value":_vm.value},on:{"input":_vm.updated}})}
var staticRenderFns = []

export { render, staticRenderFns }